import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSharedStyles } from '../Settings/useSharedStyles'
import ProfileSection from './sections/ProfileSection'
import SubscriptionSection from './sections/SubscriptionSection'
import DevicesSection from './sections/DevicesSection'
import AgreementsSection from './sections/AgreementsSection'

const ProfilePage = () => {
    const { t: translate } = useTranslation()
    const { titleStyle, container } = useSharedStyles()
    return (
        <Box sx={container}>
            <Typography mt="24px" sx={titleStyle}>
                {translate('myProfile')}
            </Typography>

            <ProfileSection />
            <SubscriptionSection />
            <DevicesSection />
            <AgreementsSection />
        </Box>
    )
}

export { ProfilePage }
